export default function (state, getters, rootState) {
    if (rootState.user.auth) {
        if (DEV) {
            return state.login.filter(i => {
                return !!i.spa;
            });
        } else {
            return state.login;
        }
    } else {
        return state.logout;
    }
}